// Angular
import { Component, OnChanges, SimpleChanges, OnInit, input } from '@angular/core';

// NGRX
import { Store } from '@ngrx/store';

// OLCI
import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import { constants } from '../../../constants';
import * as tracking from '../../../actions/tracking';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './modal-terms-of-use.component.html',
	styleUrls: ['./modal-terms-of-use.component.scss'],
    standalone: false
})
export class ModalTermsOfUseComponent implements OnChanges, OnInit {
	public readonly layoutState = input<string>();
	public readonly bundle = input<any>(null);

	public showMenu: boolean;
	public showTermsOfUseModal: boolean;
	public contentMessage: string;

	public constructor(private readonly store: Store<fromRoot.AppState>) {
		this.showTermsOfUseModal = false;
	}

	public ngOnInit(): void {
		this.contentMessage = this.getContentMessage();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['layoutState']) {
			const layoutState = changes['layoutState'].currentValue;
			if (layoutState && layoutState.openedModalName === constants.MODAL.TERMS_OF_USE) {
				this.showTermsOfUseModal = true;
				this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: terms of use: info dialog opened primary content'));
			} else if (layoutState && layoutState.openedModalName === 'close') {
				this.showTermsOfUseModal = false;
			}
		}
		if (changes['bundle']) {
			this.contentMessage = this.getContentMessage();
		}
	}

	public closeModal(): void {
		this.showTermsOfUseModal = false;
		this.store.dispatch(new olci.CloseModalAction());
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: terms of use: user closed info dialog'));
	}

	private getContentMessage(): string {
		const bundle = this.bundle();
  if (!bundle) {
			return '';
		}

		let htmlMessage = '';
		for (let i = 1; i <= 13; i++) {
			const key = 'terms.of.service.paragraph' + i;
			htmlMessage += bundle[key] ?? '';
		}

		return htmlMessage;
	}
}
